import React from 'react';

import { StyledDottedDivider } from './DottedDivider.styles';

function DottedDivider() {
  return <StyledDottedDivider />;
}

export default DottedDivider;
